import z from 'zod';

export const zodRequiredStringSchema = z.string().min(1, 'Field is required');
